<template>
  <div class="answerEdit">
    <bread-crumb></bread-crumb>
    <div class="wrap">
      <!-- 分栏 -->
      <c-title :title="`问题ID: ${questionInfo.questionId}`" />
      <!-- <div class="kvs">
        <div class="kv"><div class="k">问题标题</div><div class="v">{{ questionInfo.questionTitle }}</div></div>
        <div class="kv"><div class="k">提问人</div><div class="v">{{questionInfo.questionUser || '无'}}</div></div>
        <div class="kv"><div class="k">想获得的帮助</div><div class="v">{{ questionInfo.questionHelps || '无' }}</div></div>
        <div class="kv"><div class="k">问题描述</div>
          <div class="v" v-html="questionInfo.questionContent || '<p>无</p>'"></div>
        </div>
      </div> -->
      <questionEdit
        :isComponent="true"
        :formData="questionInfo"
        ref="questionEdit"
      />
      <!-- 分栏 -->
      <c-title :title="`回答ID: ${form.contentId}`" />
      <!-- 提问人TEXT输入框 -->
      <!-- 敏感词 -->
      <sensitive-words :sensitiveWords.sync="form.sensitiveWords" />
      <div class="content-item flex align-items-center">
        <p class="content-item-label">回答人</p>
        <el-input
          v-model="answerInfo.answerer"
          class="article_tit"
          :disabled="!answererType"
          show-word-limit
          maxlength="100"
          placeholder="请输入回答人"
          v-show="!changeAnswerer"
          @focus="focusAnswerer()"
        ></el-input>
        <div v-show="changeAnswerer" style="display: flex; align-items: center">
          <div>
            <span class="mat-left-5"> 姓名：</span>
            <el-select
              size="small"
              v-model="answerInfo.answererName"
              filterable
              remote
              placeholder="请输入回答人姓名"
              :remote-method="doctor_remoteMethod"
              :loading="loading"
              @change="selectChange"
              clearable
            >
              <el-option
                v-for="(val, index) in doctorList"
                :key="index"
                :label="`${val.docName} ${val.hospitalName}`"
                :value="val"
              >
              </el-option>
            </el-select>
            <br />
            <span class="mat-left-5"> 职级：</span>
            <el-input
              v-model="answerInfo.answererTitleName"
              class="article_tit mar-top-10"
              show-word-limit
              placeholder="请输入回答人职级"
            ></el-input>
            <br />
            <span class="mat-left-5"> 单位：</span>
            <el-input
              v-model="answerInfo.answererHospitalName"
              class="article_tit mar-top-10"
              show-word-limit
              placeholder="请输入回答人单位"
            ></el-input>
            <br />
            <span class="mat-left-5"> 部门：</span>
            <el-input
              v-model="answerInfo.answererDepartName"
              class="article_tit mar-top-10"
              show-word-limit
              placeholder="请输入回答人部门"
            ></el-input>
          </div>
          <el-button
            type="primary"
            size="mini"
            class="mar-left-10"
            @click="changeAnswererInfo()"
            >确认修改</el-button
          >
        </div>
      </div>

      <!-- 富文本编辑器 -->
      <div class="content-item flex">
        <p class="content-item-label">回答内容</p>
        <c-editor
          ref="editorRef"
          :content="form.contentParagraphs[0].paragraphContent || ''"
          index="a1"
          @editorReady="editorReady"
          @blurEditorEvent="blurEditorEvent"
        />
      </div>
      <!-- 分栏 -->
      <c-title title="基本信息" class="mar-top-20" />
      <content-label-info
        :contentId="form.contentId"
        ref="contentLabelInfo"
        :sourceType="form.sourceType"
        @indexChange="indexChange"
        :articleIndex="contentIndexes"
        :contentType="15"
      >
      </content-label-info>
      <!-- 分栏 -->
      <c-title title="疾病库" class="mar-top-20" />
      <content-label-qa
        :data="form.contentRelations"
        @changeDiseaseLabels="changeDiseaseLabels"
        :is-show-disease="isShowDisease"
        :isQuestion="isQuestion"
        :functionIds="{ queryContents: 'health_cmp_pageDiseaseInfoByParam' }"
      >
      </content-label-qa>
      <!-- 症状库 -->
      <c-title title="症状库" class="mar-top-20" />
      <symptom-label
        :csdata="form.contentSymptoms"
        @changeSymptomLabels="changeSymptomLabels"
        :functionIds="{ getSymptom: 'health_cmp_pageSymptomByName' }"
      />
      <!-- 分栏 -->
      <c-title title="标签信息" class="mar-top-20" />
      <div class="content-item flex align-items-center">
        <question-cascader
          :id="form.contentId"
          ref="questionLabel"
        ></question-cascader>
      </div>
      <div class="finish-btns">
        <el-button type="primary" v-if="auditInfoShow == 2" @click="adopt(1)"
          >通过</el-button
        >
        <el-button v-if="auditInfoShow !== 2" @click="adopt(2)">提交</el-button>
        <el-button v-if="auditInfoShow == 2" @click="rejectClick"
          >驳回</el-button
        >
        <el-button @click="adopt(3)">预览</el-button>
      </div>
    </div>
    <!-- 预览弹窗 -->
    <preview-modal
      :mUrl.sync="mUrl"
      :dialogPreVisible.sync="dialogPreVisible"
      :qrCode="qrCode"
    />
    <!--驳回弹窗-->
    <reject-modal
      :rejectForm.sync="rejectForm"
      @rejectClickHandler="rejectClickHandler"
    ></reject-modal>
  </div>
</template>

<script>
import BreadCrumb from "@/components/breadCrumb";
import CTitle from "@/components/customize/CTitle";
import QuestionCascader from "@/components/select/QuestionCascader";
import CEditor from "@/components/editor/CEditor";
import RejectModal from "@/components/pop/RejectModal";
import ContentLabelQa from "@/components/tag/ContentLabelQa";
import PreviewModal from "@/components/pop/PreviewModal";
import ContentLabelInfo from "@/components/tag/contentLabelInfo";
import SensitiveWords from "@/components/input/SensitiveWords";
import questionEdit from "./questionEdit";
import SymptomLabel from "@/components/combination/SymptomLabel";

import {
  queryQAById,
  queryListParagraph,
  queryDoctorName,
  submitQuestion,
  rejectQuestion,
  adoptQuestion,
  modifyAnswer,
} from "@/api/questionsLibrary";
import { getQRCode } from "@/utils/tools";
import utils from "@/utils";

const baseUrl = process.env.VUE_APP_BASEURL;
export default {
  name: "answerEdit",
  components: {
    BreadCrumb,
    CTitle,
    QuestionCascader,
    CEditor,
    RejectModal,
    ContentLabelQa,
    PreviewModal,
    ContentLabelInfo,
    SensitiveWords,
    questionEdit,
    SymptomLabel,
  },
  data() {
    return {
      res: {},
      contentType: 15, // 15-回答
      // 是否对外推广
      openFlag: true,
      baseUrl,
      isShowDisease: false,
      isQuestion: true,
      doctorList: [], // 匹配的体制内的医生列表
      paragraphList: [], // 段落
      editorList: {},
      auditInfoShow: "",
      rejectForm: {
        rejectlineDialog: false,
        rejectReasons: "",
        isShowBtn: [true, true], //弹窗是否能显示按钮
        ordinaryBtnText: ["取消", "确认"],
      },
      statusInfo: "", // 要往后台传的字段
      questionInfo: {
        // 问题的相关字段
        questionId: "", // 问题Id
        questionTitle: "", // 问题标题
        questionUser: "", // 提问人
        questionHelps: "", // 想要获得的帮助
        questionContent: "", // 问题描述
      },
      answerInfo: {
        // 回答人的相关字段
        answererName: "", // 回答人姓名
        answererTitleName: "", // 回答人职级
        answererHospitalName: "", // 回答人单位
        answererDepartName: "", // 回答人的部门
        answerer: "", // 回答人信息汇总
        contentIpAddress: [], // ip信息透传
      },
      docId: "", // 选中体制内医生的Id
      changeAnswerer: false, // 修改回答人时切换输入框的判断变量
      form: {
        contentId: undefined, // 答案id
        tenantId: Number(this.$commonJs.getTenantId()), // 租户id
        contentName: "", // 内容名称
        contentRelations: [], // 关联的其他内容 仅需要id和type
        contentStatus: null, // 内容状态 1 上线 2下线
        auditInfo: {}, // 审核信息
        contentLabels: [], // 标签信息
        contentParagraphs: [
          {
            paragraphContent: "", // 解决页面渲染时的报错
          },
        ], // 段落信息
        contentUsers: [], // 内容关联的用户
        keywordInfos: [], // 内容关键词
        bodyParts: [], // 身体部位
        contentAuditStatus: 1, // 内容审核状态1草稿、2待审核、3审核通过、4驳回
        departments: [], // 科室信息
        contentSymptoms: [], //绑定疾病id
        extensionContentLabels: [],
        contentChannels: [],
        contentCategorys: [],
        contentBusinesses: [],
        sensitiveWords: "",
        contentIndexes: [],
      },
      contentIndexes: [],
      // 预览弹框是否显示
      dialogPreVisible: false,
      // 预览弹框二维码
      qrCode: "",
      // 预览弹框文章链接
      mUrl: "",
      authorType: "", // 判断回答人类型
      answererType: true, // 判断回答人信息是否可编辑
      contentDiags: [],
      contentRiskControls: [],
      contentRelations: [],
      contentAttachments: [],
    };
  },
  async created() {
    if (this.$route.query.id) {
      this.form.contentId = this.$route.query.id;
      await this.getDiseaseInfoDraftDetail();
      this.getParagraph();
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.cancel, false);
  },
  mounted() {
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.cancel, false);
    }

    setTimeout(() => {
      // 添加这段代码
      const $el = document.querySelectorAll(".el-cascader-node[aria-owns]");
      console.log($el);
      Array.from($el).map((item) => item.removeAttribute("aria-owns"));
    }, 300);
  },
  methods: {
    // 症状
    changeSymptomLabels(data) {
      this.form.contentSymptoms = data;
    },
    // 回答人信息切换输入框函数
    focusAnswerer() {
      this.changeAnswerer = true;
    },
    // 修改回答人信息函数
    changeAnswererInfo() {
      // 这些变量的值 可能是 '' undefined string 三种情况
      if (this.answerInfo.answererName == undefined) {
        this.answerInfo.answererName = "";
      }
      if (this.answerInfo.answererTitleName == undefined) {
        this.answerInfo.answererTitleName = "";
      }
      if (this.answerInfo.answererHospitalName == undefined) {
        this.answerInfo.answererHospitalName = "";
      }
      if (this.answerInfo.answererDepartName == undefined) {
        this.answerInfo.answererDepartName = "";
      }
      if (
        this.answerInfo.answererName == "" &&
        (this.answerInfo.answererTitleName != "" ||
          this.answerInfo.answererHospitalName != "" ||
          this.answerInfo.answererDepartName != "")
      ) {
        this.$message.error("回答人姓名不能为空");
        return false;
      }
      this.answerInfo.answerer =
        this.answerInfo.answererName +
        " " +
        this.answerInfo.answererTitleName +
        " " +
        this.answerInfo.answererHospitalName +
        " " +
        this.answerInfo.answererDepartName;
      // 拼接后 去除前后空格
      this.answerInfo.answerer = this.answerInfo.answerer.trim();
      // 隐藏四行输入框
      this.changeAnswerer = false;
    },
    // 匹配体制内医生
    doctor_remoteMethod(val) {
      this.answerInfo.answererName = val;
      if (val.trim() != "") {
        queryDoctorName({
          tenantId: this.$commonJs.getTenantId(),
          doctorName: this.answerInfo.answererName.trim(),
        }).then((res) => {
          this.doctorList = res;
          if (this.doctorList.length == 0) {
            this.docId = "";
            this.authorType = 5;
          }
        });
      }
    },
    // 选中下拉列表内的医生
    selectChange(val) {
      this.answerInfo.answererName = val.docName;
      this.answerInfo.answererTitleName = val.docTitleName;
      this.answerInfo.answererHospitalName = val.hospitalName;
      this.answerInfo.answererDepartName = val.departName;
      this.docId = val.docId;
      this.authorType = 2;
    },
    // 根据问题Id 查询 问题详情
    getQuestionInfo(questionId) {
      queryQAById({
        contentId: questionId,
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        this.questionInfo = { questionId, ...res };
      });
    },
    cancel: function () {
      this.$router.push(`/questionAnswer/answerList`);

      this.hopStorage();
    },
    hopStorage() {
      // 跳转列表页存储状态
      sessionStorage.setItem("questionState", 1);
    },
    // 内容索引赋值
    indexChange(val) {
      console.log([{ indexId: val[val.length - 1] }], val);
      this.contentIndexes = val;
    },
    // 通过、提交
    adopt(type) {
      this.initFormBeforeAddOrUpdate();
      if (!this.checkBeforeAddOrUpdate()) {
        return;
      }
      if (!utils.copyPictureCheck(this.form.contentParagraphs, this)) return;
      let params = {
        contentType: this.contentType,
        contentName: this.questionInfo.contentName,
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.form.contentId,
        statusInfo: this.statusInfo,
        auditInfo: this.form.auditInfo,
        contentLabels: this.form.extensionContentLabels,
        contentParagraphs: this.form.contentParagraphs,
        contentDiseases: this.form.contentRelations,
        contentSymptoms: this.formatSymptomData(this.form.contentSymptoms, 1), //  症状
        authors:
          this.authorType == 5
            ? {
                authorType: this.authorType,
                authorName: this.answerInfo.answererName,
                titleName: this.answerInfo.answererTitleName,
                hospitalName: this.answerInfo.answererHospitalName,
                departName: this.answerInfo.answererDepartName,
              }
            : {
                authorType: this.authorType,
                authorId: this.docId,
              },
        contentAttributes: this.$refs.contentLabelInfo.dataProcessing() || [],
        contentDiags: this.contentDiags || [],
        contentRiskControls: this.contentRiskControls || [],
        contentRelations: this.contentRelations || [],
        contentAttachments: this.contentAttachments || [],
        contentIpAddress: this.answerInfo.contentIpAddress || [],
        contentIndexes: this.form.contentIndexes, // 索引字段
      };
      console.log("params", params);
      let count = 0;
      this.$refs.questionEdit.form.contentRelations =
        this.form.contentRelations;

      this.$refs.questionEdit.adopt(type, () => {
        count++;
        if (count === 2) {
          this.fn(type);
        }
      });
      modifyAnswer(params).then((res) => {
        count++;
        if (count === 2) {
          this.fn(type);
        }
      });
    },
    fn(type) {
      if (type == 1) {
        this.handleAdopt();
      } else if (type == 2) {
        let params2 = {
          tenantId: Number(this.$commonJs.getTenantId()),
          contentId: this.form.contentId,
        };
        submitQuestion(params2)
          .then((res) => {
            if (res) {
              // this.$router.push(`/questionAnswer/answerList`);
              this.$message.success("提交成功");
              // this.hopStorage();
              // setTimeout(() => {
              //   window.close();
              // }, 300);
            }
          })
          .catch((err) => {
            this.$message.error(err.msg + "提交失败");
          });
      } else if (type == 3) {
        // 预览
        this.articlePreview(this.questionInfo.questionId);
      }
    },

    //新增通过回调
    handleAdopt() {
      let params1 = {
        tenantId: Number(this.$commonJs.getTenantId()),
        contentId: this.form.contentId,
      };
      adoptQuestion(params1)
        .then((res) => {
          if (res) {
            // this.$router.push(`/questionAnswer/answerList`);
            this.$message.success("通过成功");
            // this.hopStorage();
            setTimeout(() => {
              window.close();
            }, 300);
          }
        })
        .catch((err) => {
          this.$message.error(err.msg + "通过失败");
        });
    },

    // 预览
    articlePreview(val) {
      this.dialogPreVisible = true;
      this.previewDialog = true;
      this.jumpUrl(val);
    },
    jumpUrl(urlId) {
      const urlAddress = "//beta-api.m.jd.com";
      const url = `https://laputa${
        this.baseUrl == urlAddress ? "-yf" : ""
      }.healthjd.com/content/article/qadetail?id=${urlId}`;
      this.mUrl = url;
      getQRCode(url, (url) => {
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },
    // 驳回
    rejectClick() {
      this.rejectForm.rejectlineDialog = true;
    },
    rejectClickHandler(arg) {
      if (arg === "two") {
        if (this.rejectForm.rejectReasons === "") {
          this.$message.error("驳回理由不能为空");
        } else {
          //contentAuditStatus:1草稿、2待审核、3审核通过、4驳回 9撤销投稿
          rejectQuestion({
            contentId: this.form.contentId,
            tenantId: this.$commonJs.getTenantId(),
            remark: this.rejectForm.rejectReasons,
          })
            .then((res) => {
              this.rejectForm.rejectlineDialog = false;
              this.rejectForm.rejectReasons = ""; //置空驳回原因
              this.$message.success("驳回成功");
              // this.$router.push(`/questionAnswer/answerList`);
              setTimeout(() => {
                window.close();
              }, 300);
            })
            .catch((err) => {
              this.$message.error(err.msg || "发布失败");
            });
        }
      } else {
        this.rejectForm.rejectlineDialog = false;
      }
    },
    // 恢复段落内容
    restoreContentParagraphs({ editor, index }) {
      var article = this.$commonJs.getArticleDataFromCache(this.form.contentId);
      if (!article) {
        return;
      }
      this.$set(
        this.paragraphList[index],
        "content",
        article.contentParagraphs[index].paragraphContent
      );
    },
    editorReady(data) {
      this.editorList["editor" + data.index] = data.editor;
      this.restoreContentParagraphs(data);
    },
    // 处理数据
    initFormBeforeAddOrUpdate() {
      this.$refs.questionLabel.getFormLabelData(this.form);
      this.form.contentParagraphs = [];
      // 索引
      if (this.contentIndexes.length > 0) {
        this.form.contentIndexes = [
          { indexId: this.contentIndexes[this.contentIndexes.length - 1] },
        ];
      }
      this.paragraphList.map((item, index) => {
        this.form.contentParagraphs.push({
          paragraphCode: item.code,
          paragraphName: item.desc,
          paragraphType: item.type,
          paragraphContent:
            this.editorList["editora" + (index + 1)].getContent() || "",
        });
      });
    },
    // 校验
    checkBeforeAddOrUpdate() {
      // 展示四个输入框时 是编辑状态，不能被提交
      // 展示一个输入框时  是确认状态，才能被提交
      if (this.changeAnswerer) {
        this.$message.error("请对回答人修改进行确认");
        return false;
      }
      let isParagraphsPass = true;
      isParagraphsPass = this.form.contentParagraphs.some((item) => {
        return item.paragraphContent != "";
      });
      if (!isParagraphsPass) {
        this.$message.error("回答正文不能为空");
        return false;
      }
      // 索引选择必选, 若为sourceType 主站问答为10 不必选
      if (
        this.form.contentIndexes.length === 0 &&
        this.form.sourceType !== 10 &&
        this.form.sourceType !== 11
      ) {
        this.$message.error("请选择内容索引");
        return false;
      }
      let contentLength = this.form.contentParagraphs.some((item) => {
        return this.checkAnswerContent(item.paragraphContent);
      });
      if (!contentLength) {
        this.$message.error("回答正文不能少于20字");
        return false;
      }

      return true;
    },
    // 检验回答内容不小于20字
    checkAnswerContent(text) {
      // 文本编译器 可能有问题  会把空格转换为 &nbsp;  而且转换不完全  五个只会转换三个
      // 目前检验没问题  后续可优化修改
      while (text.indexOf("&nbsp;") != -1) {
        text = text.replace("&nbsp;", "&");
      }
      let content = text.trim().split("");
      // 之所以是27 是因为 还包含了  <p></p>  这七个字符
      if (content.length >= 27) {
        return true;
      }
      return false;
    },
    // 获取文章详情
    async getDiseaseInfoDraftDetail() {
      await queryQAById({
        contentId: this.form.contentId,
        tenantId: this.$commonJs.getTenantId(),
      }).then((res) => {
        this.res = res;
        this.statusInfo = res.statusInfo;
        this.contentDiags = res.contentDiags || [];
        this.contentRiskControls = res.contentRiskControls || [];
        this.contentAttachments = res.contentAttachments || [];
        this.contentRelations = res.contentRelations || [];
        this.displayInfo(res);
      });
    },
    // 格式化传递给后端的 症状库 数据，因为后端不能传symptomName; type 1 添加str， 2 去掉str
    formatSymptomData(data, type) {
      const arr = [];
      data.forEach((item) => {
        console.log(
          "🚀 ~ file: index.vue:230 ~ data.forEach ~ item:",
          item,
          type
        );
        const tmpObj = {};
        tmpObj.symptomId = item.symptomId;
        if (type === 1) {
          tmpObj.symptomNameStr = item.symptomName;
        } else {
          tmpObj.symptomName = item.symptomNameStr;
        }
        arr.push(tmpObj);
      });
      console.log("🚀 ~ file: index.vue:374 ~ formatSymptomData ~ arr:", arr);
      return arr;
    },
    // 反显
    displayInfo(res) {
      // 返显
      if (res.auditInfo) {
        this.auditInfoShow = res.auditInfo.auditStatus;
      }
      // 症状反显
      if (res.contentSymptoms) {
        console.log(
          "🚀 ~ file: answerEdit.vue:667 ~ displayInfo ~ res.contentSymptoms:",
          res.contentSymptoms
        );
        this.form.contentSymptoms = this.formatSymptomData(
          res.contentSymptoms,
          2
        ); //  症状
      }
      // 索引反显
      const treeToArrObj = (obj) => {
        if (!obj.contentIndexes || obj.contentIndexes.length === 0) {
          return { indexId: obj.indexId };
        }
        treeToArrObj(obj.contentIndexes[0]);
      };
      const treeToArr = (obj, arr) => {
        if (obj && obj.indexId) {
          arr.push(obj.indexId);
          treeToArr(obj.contentIndexes[0], arr);
        }
        if (!obj || !obj.contentIndexes || obj.contentIndexes.length === 0) {
          return arr;
        }
      };
      if (res?.contentIndexes?.length > 0) {
        const arr = [];
        treeToArr(res.contentIndexes[0], arr);
        this.form.contentIndexes = [treeToArrObj(res.contentIndexes[0])];
        this.contentIndexes = arr;
      }
      const {
        contentName,
        contentParagraphs,
        contentRiskControls,
        contentIpAddress,
      } = res;
      this.form.contentParagraphs = contentParagraphs || [];
      this.form.contentName = contentName;
      this.form.contentRelations = res.contentDiseases;
      // 把问题的审核状态  作为入参
      const { auditStatus, auditTime, auditUser, remark } = res.auditInfo;
      this.form.auditInfo.auditStatus = auditStatus;
      this.form.auditInfo.auditTime = auditTime;
      this.form.auditInfo.auditUser = auditUser;
      this.form.auditInfo.remark = remark;
      // 回答id
      this.form.contentId = res.contentId;
      // 问题id
      this.questionInfo.questionId = res.contentRelations[0].contentId;
      // 根据问题id查询问题详情
      this.getQuestionInfo(this.questionInfo.questionId);
      // 回答人信息
      if (res.authors) {
        let authors = res.authors.filter((item) => {
          if (item.authorType == 2 || item.authorType == 5) {
            return item;
          }
        });
        if (authors.length > 0) {
          // 获取的符合条件的回答人信息
          var {
            authorId,
            authorName,
            departName,
            hospitalName,
            titleName,
            authorType,
          } = authors[0];
        } else {
          // eslint-disable-next-line no-redeclare
          var authorId = "";
          // eslint-disable-next-line no-redeclare
          var authorName = "";
          // eslint-disable-next-line no-redeclare
          var departName = "";
          // eslint-disable-next-line no-redeclare
          var hospitalName = "";
          // eslint-disable-next-line no-redeclare
          var titleName = "";
          // eslint-disable-next-line no-redeclare
          var authorType = 5;
        }
      }
      let arr = [];
      contentRiskControls &&
        contentRiskControls.length > 0 &&
        contentRiskControls.map((val) => {
          arr.push(val.sensitiveWord);
        });
      const sensitiveWordsStr = arr.length > 0 ? arr.join(",") : "";
      this.form.sensitiveWords = sensitiveWordsStr;
      if (authorId) {
        this.docId = authorId;
      }
      if (authorName) {
        this.answerInfo.answererName = authorName;
      }
      if (departName) {
        this.answerInfo.answererDepartName = departName;
      }
      if (hospitalName) {
        this.answerInfo.answererHospitalName = hospitalName;
      }
      if (titleName) {
        this.answerInfo.answererTitleName = titleName;
      }
      this.answerInfo.answerer =
        this.answerInfo.answererName +
        " " +
        this.answerInfo.answererTitleName +
        " " +
        this.answerInfo.answererHospitalName +
        " " +
        this.answerInfo.answererDepartName;
      this.answerInfo.answerer = this.answerInfo.answerer.trim();

      // 判断是否是体制内医生  2-体制内医生  5-体制外回答者  决定是否能被编辑
      this.authorType = authorType;
      if (this.authorType == 2) {
        this.answererType = false;
      } else {
        this.authorType = 5;
      }
      if (contentIpAddress) {
        this.answerInfo.contentIpAddress = contentIpAddress;
      }
      var cache_article = this.$commonJs.getArticleDataFromCache(res.contentId);
      var isFirstAdd = this.paragraphList.length == 0;
      res.contentParagraphs &&
        res.contentParagraphs.map((item, index) => {
          if (isFirstAdd) {
            this.paragraphList.push({
              code: item.paragraphCode,
              desc: item.paragraphName,
              type: item.paragraphType,
              content: item.paragraphContent || "",
            });
          } else {
            for (var i = 0; i < this.paragraphList.length; i++) {
              if (this.paragraphList[i].code == item.paragraphCode) {
                this.paragraphList[i].content == item.paragraphContent || "";
                break;
              }
            }
          }
          try {
            var isEditorInited = setInterval(() => {
              var edd = this.editorList["editora" + (index + 1)];
              if (edd) {
                clearInterval(isEditorInited);
                edd.setContent(item.paragraphContent || "");
              }
            }, 100);
          } catch (error) {
            console.log(error);
          }
        });
      if (res.sourceType) {
        this.form.sourceType = res.sourceType;
      }
    },
    //获取疾病信息
    changeDiseaseLabels(data) {
      // 关联疾病
      this.form.contentRelations = data;
    },
    // 获取段落
    getParagraph() {
      queryListParagraph({
        tenantId: this.$commonJs.getTenantId(),
        type: 11,
      })
        .then((res) => {
          this.paragraphList = res || [];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 文章缓存处理  目前缓存有问题  刷新页面但不点击保存的时候 无法保留复现 后续可按需求考虑是否优化
    blurEditorEvent(editor, index) {
      // 编辑文章不做临时保存操作
      if (this.form.contentId) {
        return;
      }
      if (this.paragraphList.length > 0) {
        this.paragraphList[index].content = editor.getContent() || "";
      }
      // eslint-disable-next-line no-undef
      // var tipDom = $(
      //   '<div class="successfully" style="position: absolute; top: 0; right: 15px;color: green;">保存成功</div>'
      // );
      // // eslint-disable-next-line no-undef
      // let ParentElement = $(editor.editorContainer)
      //   .find(".tox-toolbar__group")
      //   .eq(0);
      // let subelement = ParentElement.find(".successfully");
      // // 只创建一次
      // if (subelement.length == 0) {
      //   // eslint-disable-next-line no-undef
      //   $(editor.editorContainer)
      //     .find(".tox-toolbar__group")
      //     .eq(0)
      //     .append(tipDom);
      // }
      // clearTimeout(this.tipTimeout);
      // this.tipTimeout = setTimeout(function() {
      //   // eslint-disable-next-line no-undef
      //   var DeleteElement = $(".tox-toolbar__group .successfully:eq(0)");
      //   if (DeleteElement) {
      //     DeleteElement.remove();
      //   }
      // }, 500);

      var cacheArticle = this.$commonJs.getArticleDataFromCache(
        this.form.contentId
      );
      if (cacheArticle) {
        this.form.contentParagraphs = cacheArticle.contentParagraphs;
      } else {
        // 如果不存在，则新增一篇文章
        this.paragraphList.forEach((item) => {
          this.form.contentParagraphs.push({
            paragraphCode: item.code,
            paragraphName: item.desc,
            paragraphType: item.type,
            paragraphContent: item.content || "",
          });
        });
      }
      this.form.contentParagraphs[index].paragraphContent =
        editor.getContent() || "";
      this.$commonJs.setCacheArticleData(this.$commonJs.deepClone(this.form));
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/common/mixin.scss";
@import "@/styles/article_common.scss";

.answerEdit {
  @include article_common;
  // 弹窗提示的body样式
  :deep(.el-dialog__body) {
    padding: 30px 26px 0px 26px !important;
  }
  // 表单Item样式
  .wrap .content-item .content-item-label {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  :deep(.content-item p) {
    width: 107px;
    text-align: right;
    margin-right: 10px;
    flex-shrink: 0;
  }
  .kvs {
    padding: 0 10px 20px;
    .kv {
      position: relative;
      color: #2c3443;
      font-size: 14px;
      margin: 15px 0;
      .k {
        position: absolute;
        top: 0;
        left: 0;
        width: 120px;
        text-align: right;
      }
      .v {
        padding-left: 140px;
        word-break: break-all;
        white-space: normal;
      }
    }
  }
}

.finish-btns {
  position: fixed;
  text-align: center;
  width: 85%;
  background-color: #ffffff;
  bottom: 0;
}
.mat-left-5 {
  margin-left: 5px;
}
.mar-left-10 {
  margin-left: 10px;
}
.mar-top-10 {
  margin-top: 10px;
}
</style>
